import './App.css'
import './index.css'

const imageNames = [
    'Render-Portfolio.jpg',
    'townhomes-under-park.png',
    'duplex.png',
    'flats-over-flex.png',
    'Flats-over-retail.png',
    'townhomes.png',
    'scenario-3.png'
]

const baseUrl = 'https://irosenb-portfolio.s3.us-west-2.amazonaws.com/'

export function Graphics() {
    return (
        <>
        <div className="graphics">
            <h2 className="heading">Graphics</h2>
            <p>I have been trained in using Rhino, Grasshopper, AutoCAD, and Indesign.</p>
            <p>Sample work below:</p>
            {
                imageNames.map((file, i) => (
                    <div>
                        <img key={i} className='object-contain' src={`${baseUrl}${file}`} alt="Sample work" />
                    </div>
                ))
            }
        </div>
        </>
    )
}